const translations = {
  "en": {
    "I'm cross-checking your portfolio. About 20 seconds.": "I'm digging into your money. About 20 seconds."
  },
  "zh-tw": {
    "I'm cross-checking your portfolio. About 20 seconds.": "我正在深入研究你的資金。約 20 秒。"
  }
};

export default translations;
